/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { RouterUpgradeInitializer, locationSyncBootstrapListener, setUpLocationSync } from './public_api';
//# sourceMappingURL=upgrade.js.map